import React from 'react';
import { useAuth } from '../AuthContext';
import MasterBulkTrashPanel from './MasterBulkTrashPanel';
import { previewPersonBulkTrash, confirmPersonBulkTrash } from '../services/personBulkTrashService';

export default function PersonBulkTrashExportPanel({ kind, onCompleted }) {
  const { user } = useAuth();
  if (user?.isMaster !== true || !['students', 'attendees'].includes(kind)) return null;
  const noun = kind === 'students' ? 'alunos' : 'atendidos';
  return <div className="master-bulk-trash-export">
    <h3>Exclusão de todos os {noun}</h3>
    <p>Esta ação abrange todos os {noun} e seus dados pessoais vinculados, independentemente dos filtros da consulta. Cursos, turmas, grupos e configurações serão preservados.</p>
    <MasterBulkTrashPanel moduleLabel={`Todos os ${noun} e seus dados pessoais vinculados`} actionLabel={`Excluir todos os ${noun}`} onPreview={() => previewPersonBulkTrash(kind)} onConfirm={confirmation => confirmPersonBulkTrash(kind, confirmation)} onCompleted={onCompleted} />
  </div>;
}
